import React, { useState } from 'react';
import { cn } from '../lib/utils';
import { Check, Copy } from 'lucide-react';

export function CopyButton({
  text,
  className,
  title = 'Kopjo',
  copiedTitle = 'U kopjua!',
  size = 'sm',
  variant = 'ghost',
  onClick,
  ...props
}) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async (e) => {
    e.stopPropagation();
    if (!text) return;
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      onClick?.(e);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy to clipboard:', err);
    }
  };

  return (
    <button
      type="button"
      onClick={handleCopy}
      title={copied ? copiedTitle : title}
      aria-label={copied ? copiedTitle : title}
      className={cn(
        'relative inline-flex items-center justify-center rounded-lg transition-all cursor-pointer',
        'text-zinc-500 hover:text-zinc-900 dark:text-zinc-400 dark:hover:text-zinc-100',
        'hover:bg-zinc-100 dark:hover:bg-zinc-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-zinc-400',
        size === 'sm' && 'h-7 w-7 p-1',
        size === 'xs' && 'h-6 w-6 p-1 text-xs',
        size === 'md' && 'h-8 w-8 p-1.5',
        copied && 'text-emerald-600 dark:text-emerald-400 bg-emerald-50 dark:bg-emerald-950/40',
        className
      )}
      {...props}
    >
      <Check
        size={size === 'xs' ? 12 : 14}
        className={cn(
          'text-emerald-600 dark:text-emerald-400 transition-all duration-200',
          copied ? 'scale-100 opacity-100' : 'absolute scale-50 opacity-0'
        )}
      />
      <Copy
        size={size === 'xs' ? 12 : 14}
        className={cn(
          'transition-all duration-200',
          copied ? 'absolute scale-50 opacity-0' : 'scale-100 opacity-100'
        )}
      />
    </button>
  );
}

export default CopyButton;
